// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


let Types = {};

let Autosizer = {};

let FixedSizeInstance = {};

let VariableSizeInstance = {};

function InfiniteLoader(Instance) {
  return {};
}

let FixedSizeList = {};

let VariableSizeList = {};

exports.Types = Types;
exports.Autosizer = Autosizer;
exports.FixedSizeInstance = FixedSizeInstance;
exports.VariableSizeInstance = VariableSizeInstance;
exports.InfiniteLoader = InfiniteLoader;
exports.FixedSizeList = FixedSizeList;
exports.VariableSizeList = VariableSizeList;
/* No side effect */
